import { GetScriptsGraphQL } from 'hooks/shopify/queries/get-scripts.graphql';
import { shopifyGraphQL } from 'hooks/shopify/shopify-graphql';
import { useState } from 'react';

const SCRIPT_TAG_DELETE_MUTATION = /* GraphQL */ `
    mutation ScriptTagDelete($id: ID!) {
        scriptTagDelete(id: $id) {
            deletedScriptTagId
            userErrors {
                field
                message
            }
        }
    }
`;

interface UseScriptTagDeleteReturn {
    deleteScriptTags: (scriptTags: GetScriptsGraphQL[]) => Promise<void>;
    isDeleting: boolean;
}

export const useScriptTagDelete = (): UseScriptTagDeleteReturn => {
    const [isDeleting, setIsDeleting] = useState(false);

    const deleteScriptTags = async (scriptTags: GetScriptsGraphQL[]) => {
        setIsDeleting(true);
        try {
            await Promise.all(scriptTags.map((tag) => shopifyGraphQL(SCRIPT_TAG_DELETE_MUTATION, { id: tag.id })));
        } finally {
            setIsDeleting(false);
        }
    };

    return { deleteScriptTags, isDeleting };
};
